import type { FC } from "react"

import { exhaustiveGuard } from "@forento/core/utilities/switch"

import { cn } from "../utilities/tailwind"
import { ApiVideoPlayer, BunnyPlayer } from "./VideoPlayer"

type Props = {
	video: { playableDate?: Date | null; id?: number } & (
		| { host: "apiVideo"; apiVideoId: string }
		| { host: "bunny"; bunnyVideoId: string }
	)
	onTrackWatch?(progress: number): void
	className?: string
}
const HostedVideoPlayer: FC<Props> = ({ video, onTrackWatch, className }) => {
	if (video.playableDate === null) {
		return (
			<div className={cn("flex aspect-video w-full items-end bg-neutral-950 p-6 sm:p-8", className)}>
				<div className="w-full max-w-sm">
					<div className="mb-4 flex gap-1.5">
						{[0, 1, 2, 3].map(i => (
							<div
								key={i}
								className="size-2 animate-pulse rounded-sm bg-neutral-500"
								style={{ animationDelay: `${i * 0.2}s` }}
							/>
						))}
					</div>
					<p className="text-lg font-medium tracking-tight text-neutral-200">Encoding</p>
					<p className="mt-0.5 text-xs text-neutral-500">Playback in a few minutes</p>
				</div>
			</div>
		)
	}

	switch (video.host) {
		case "bunny": {
			return <BunnyPlayer videoId={video.bunnyVideoId} onTrackWatch={onTrackWatch} className={className} />
		}
		case "apiVideo": {
			return <ApiVideoPlayer apiVideoId={video.apiVideoId} className={className} />
		}
		default:
			return exhaustiveGuard(video)
	}
}

export default HostedVideoPlayer
